
import Btn from "./Btn";
import FormMixin from "../Form/FormMixin";

export default {
    name: "FormBtn",

    mixins: [Btn, FormMixin],

    methods: {
        handleClick(event) {
            event.preventDefault();
            this.submit();
        }
    }
}
